// @flow

import { LOG_IN, LOG_OUT } from '../actionTypes';
import type { reduxAction } from '../dataStoreTypes';

const account = (state: any = {}, action: reduxAction) => {
  switch (action.type) {
    case LOG_IN:
      return {
        ...state,
        authed: true,
      };
    case LOG_OUT:
      return {
        ...state,
        authed: false,
      };
    default:
      return state;
  }
};

export default account;

export const selectAccount = {
  authed: (state: any): boolean => state.account.authed,
};
